import React, { useEffect, useRef } from 'react';
import { CallOverlayItem } from './call-overlay-item';
import { Camera } from './camera';
import { Microphone } from './microphone';
import './call-overlay.scss';
export const CallOverlay = ({ hasVideo, hasAudio }) => {
    const cameraOverlayRef = useRef();
    const microphoneOverlayRef = useRef();
    useEffect(() => {
        microphoneOverlayRef.current.hide();
    }, [hasVideo]);
    useEffect(() => {
        cameraOverlayRef.current.hide();
    }, [hasAudio]);
    return (<div className="call-overlay">
      <CallOverlayItem className="call-overlay__camera" disabled={!hasVideo} ref={cameraOverlayRef}>
        <Camera disabled={!hasVideo}/>
      </CallOverlayItem>

      <CallOverlayItem className="call-overlay__microphone" disabled={!hasAudio} ref={microphoneOverlayRef}>
        <Microphone disabled={!hasAudio}/>
      </CallOverlayItem>
    </div>);
};
